<template>
  <v-data-table
    ref="dataTable"
    :items="items"
    :headers="headers"
    item-key="id_store"
    :loading="loading"
  >
    <template v-slot:item.tags="{ item }">
      <j-select
        v-if="$vuetify.breakpoint.xsOnly"
        multiple
        combo-box
        chips
        simple-item
        hashtag
        hide-details
        :items="getUniqueTags"
        :value="item.tags"
        @change="v => onChange(v, item)"
      ></j-select>
      <v-combobox
        v-else
        multiple
        chips
        deletable-chips
        hide-details
        :items="getUniqueTags"
        :value="item.tags"
        autocomplete="off"
        :search-input.sync="searchInput"
        @change="v => onChange(v, item)"
      ></v-combobox>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
import { api } from "@/api";
export default {
  name: "RecipeProductStoreTagsInput",
  props: {
    product: {
      required: true
    },
    tags: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      "getStoreId",
      "getOrganisationId",
      "getStoresAvailables",
      "getRecipes",
      "getProducts",
      "getTagCategories"
    ]),
    getUniqueTags() {
      return [
        ...new Set([
          ...this.getRecipes
            .filter(x => x.data !== null)
            .map(x => x.data.tags)
            .flat(),
          ...this.getProducts
            .filter(x => x.data !== null)
            .map(x => x.data.tags)
            .flat(),
          ...this.getTagCategories.map(x => x.tags).flat()
        ])
      ];
    }
  },
  mounted() {
    this.items = [
      ...this.getStoresAvailables.filter(
        x => x.organisation == this.getOrganisationId
      )
    ].map(x => {
      return {
        ...x,
        tags: this.tags.find(t => t.store == x.id_store)
          ? this.tags.find(t => t.store == x.id_store).tags
          : []
      };
    });
  },
  data() {
    return {
      searchInput: "",
      loading: false,
      items: [],
      headers: [
        { value: "name_store", text: "Succursale" },
        { value: "tags", text: "Mots clés" }
      ]
    };
  },
  methods: {
    onChange(v, item) {
      this.searchInput = "";
      if (v.length > 0 && v.slice(-1)[0].charAt(0) === "#") {
        item.tags = v;
      } else if (v.length > 0 && v.slice(-1)[0].charAt(0) !== "#") {
        v[v.length - 1] = `#${v.slice(-1)[0]}`;
        item.tags = v;
      } else {
        item.tags = v;
      }
    },
    async save() {
      const tasks = [];
      this.items.forEach(x => {
        if (this.tags.find(t => t.store == x.id_store)) {
          let storeTags = this.tags.find(t => t.store == x.id_store);
          storeTags.tags = x.tags;
          tasks.push(api.putRecipeProductStoreTags(storeTags.id, storeTags));
        } else {
          const data = {
            fk_product: this.product.id,
            store: x.id_store,
            tags: x.tags
          };
          tasks.push(api.postRecipeProductStoreTags(data));
        }
      });
      await Promise.all(tasks);
    }
  }
};
</script>

<style lang="scss" scoped></style>
